module.exports = __webpack_public_path__ + "img/escudo.07c66c4f.png";